import { ProjectTab } from "../../ViewProjectPage.types";
import {
  Activity,
  BarChart3,
  FileText,
  Kanban,
  Settings,
  Users,
  Edit,
} from "lucide-react";

export const projectTabs = [
  {
    value: "activity",
    icon: Activity,
    labelKey: "projects.tabs.activity",
  },
  {
    value: "issues",
    icon: Edit,
    labelKey: "projects.tabs.issues",
  },
  {
    value: "board",
    icon: Kanban,
    labelKey: "projects.tabs.board",
  },
  {
    value: "models",
    icon: FileText,
    labelKey: "projects.tabs.models",
  },
  {
    value: "statistics",
    icon: BarChart3,
    labelKey: "projects.tabs.statistics",
  },
  {
    value: "team",
    icon: Users,
    labelKey: "projects.tabs.team",
  },
  {
    value: "settings",
    icon: Settings,
    labelKey: "projects.tabs.settings",
  },
] satisfies {
  value: ProjectTab;
  icon: React.ElementType;
  labelKey: string;
}[];
